const BANNER_APPEARANCE_TIME = 5 * 1000;
const STATE_KEY = 'notificationBanner';

export { BANNER_APPEARANCE_TIME, STATE_KEY };
